var map = {
	"./Banner.vue": 5918,
	"./BigMinBanner.vue": 8349,
	"./ColumnName.vue": 9767,
	"./Footer.vue": 2801,
	"./HtmlContent.vue": 3358,
	"./HuaxianAttractCarrier.vue": 4667,
	"./HuaxianAttractProjectList .vue": 622,
	"./HuaxianBanner.vue": 1061,
	"./HuaxianBannerLink.vue": 8752,
	"./HuaxianBreadcrumb.vue": 628,
	"./HuaxianBrokenLine.vue": 6626,
	"./HuaxianCircular.vue": 9082,
	"./HuaxianColumnar.vue": 8686,
	"./HuaxianContact.vue": 2606,
	"./HuaxianCooperationList.vue": 7166,
	"./HuaxianCreditModel.vue": 8042,
	"./HuaxianCreditPolicy.vue": 1201,
	"./HuaxianFinanceProject.vue": 6178,
	"./HuaxianFinanceProjectDetail.vue": 3567,
	"./HuaxianFinanceProjectList.vue": 3410,
	"./HuaxianGeneralSituation.vue": 3119,
	"./HuaxianIndexNews.vue": 8482,
	"./HuaxianInfo.vue": 5227,
	"./HuaxianMenuDetail.vue": 1477,
	"./HuaxianNewDetail.vue": 3982,
	"./HuaxianNewList.vue": 9621,
	"./HuaxianOtherFinance.vue": 8656,
	"./HuaxianOtherNews.vue": 7778,
	"./HuaxianProjectDetail.vue": 4444,
	"./HuaxianProjectGrid.vue": 9720,
	"./HuaxianPublicity.vue": 3277,
	"./HuaxianSpecial.vue": 7361,
	"./HuaxianTitleList.vue": 2917,
	"./HuaxianVillageInfo.vue": 9230,
	"./HuaxianVillageInfoDetail.vue": 3608,
	"./HuaxiannewsRotation.vue": 1085,
	"./ListComponent.vue": 811,
	"./PopFrame.vue": 4617,
	"./Quicknavigation.vue": 8631,
	"./SanNong.vue": 5103,
	"./SearchList.vue": 2243,
	"./TuiJian.vue": 6812,
	"./VideoPlayback.vue": 8225,
	"./VideoPlayer.vue": 3023,
	"./ZhongDian.vue": 6045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5951;